import { useEffect, useState } from "react";
import styles from "./HomePage.module.scss";
import Presentation from "./components/Presentation";
import Banner from "../../components/Banner/Banner";
import img from "../../assets/images/prestation/regard.webp";
import Links from "../../components/Links/Links";
import { fetchRates } from "../../api/rates";
import Cards from "../../components/Cards/Cards";

import { useActivePromotions } from "../../hooks/useActivePromotions";
import PromotionModal from "../../components/Prestations/PromotionModal/PromotionModal";

const getTodayKey = () => {
  const now = new Date();

  return [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, "0"),
    String(now.getDate()).padStart(2, "0"),
  ].join("-");
};

function Home() {
  const [rates, setRates] = useState([]);
  const [isPromotionModalOpen, setIsPromotionModalOpen] = useState(false);

  const {
    promotions: activePromotions,
    loading: promotionsLoading,
    error: promotionsError,
  } = useActivePromotions();

  const activePromotion = activePromotions?.[0];

  useEffect(() => {
    const getRates = async () => {
      const response = await fetchRates();
      setRates(response.data);
    };

    getRates();
  }, []);

  useEffect(() => {
    if (!activePromotion) {
      setIsPromotionModalOpen(false);
      return;
    }

    const storageKey = `promotion-modal-last-display-${activePromotion.id}`;
    const today = getTodayKey();

    try {
      const lastDisplayDate = localStorage.getItem(storageKey);

      setIsPromotionModalOpen(lastDisplayDate !== today);
    } catch {
      setIsPromotionModalOpen(true);
    }
  }, [activePromotion]);

  const closePromotionModal = () => {
    if (activePromotion) {
      const storageKey = `promotion-modal-last-display-${activePromotion.id}`;

      try {
        localStorage.setItem(storageKey, getTodayKey());
      } catch {
        // On ferme tout de même la modal si le stockage est inaccessible.
      }
    }

    setIsPromotionModalOpen(false);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.banner}>
          <Banner text="Esthéticienne à Valenciennes" backgroundImage={img} />
        </div>

        <Presentation />

        <Cards title="prestations" data={rates} />

        <Links />
      </div>

      {!promotionsLoading &&
        !promotionsError &&
        activePromotion &&
        isPromotionModalOpen && (
          <PromotionModal
            promotion={activePromotion}
            onClose={closePromotionModal}
          />
        )}
    </>
  );
}

export default Home;
